<template>
	<div class="container">
		<div class="row">
			<section class="form-container box-center">
				<h2 class="text-center text-uppercase">Log In</h2>
				<div class="col-sm-6 col-sm-offset-4">
					<form class="form-horizontal" novalidate role="form" @submit="login">
					  <div class="form-group">
					    <div class="col-sm-9">
					      <input type="email" class="form-control" :class="{ 'has-error': err.email }" id="email" placeholder="Email" v-model="form.email"/>
					    </div>
					  </div>
					  <div class="form-group">
					    <div class="col-sm-9"> 
					      <input type="password" class="form-control" :class="{ 'has-error': err.password }" id="pwd" placeholder="Contraseña" v-model="form.password">
					    </div>
					  </div>
					  <div class="form-group"> 
					    <div class="col-sm-9">
					      <input type="submit" style="margin-left:0;" class="btn btn-black btn-lg" value="Ingresar"/>
					    </div>
					  </div>
					</form>
					<div v-if="has_error" class="text-center error col-sm-9">{{ msg_error }}</div>
				</div>
			</section>
		</div>
	</div>
</template>

<style scoped>
	h2 {
		font-family: "Open Sans";
		font-size: 30px;
		color: #6d6e71;
	}
</style>

<script>
import { loginUser } from '../../store/actions';
import { router } from '../../routes/routes';

export default {
	// ------ DATA ------
	
	data() {
		return {
			form: {
				email: null,
				password: null
			},
			err: {},
			has_error: null,
			msg_error: null
		}
	},

	// ------ VUEX ------
	
	vuex: {
		actions: {
			loginUser
		}
	},

	// ------ METHODS ------
	
	methods: {
		login(e) {
			e.preventDefault();
			this.has_error = false;
			this.msg_error = null;
			this.err = {};
			this.validate();

			if (this.has_error)
				return;

			this.loginUser(this.form, '/admin/users');
		},

		validate() {
			// Check if the fields are not empty.
			if (!this.form.password) {
				this.err.password = true;
				this.has_error = true;
				this.msg_error = 'Ingresa tu contraseña';
			}

			if (!this.form.email) {
				this.err.email = true;
				this.has_error = true;
				this.msg_error = 'Ingresa tu correo';
			}
		},

		isLogin() {
			let user = JSON.parse(localStorage.getItem('lasddi')) || {};
			// Check if the user is logged, and redirect to admin users.
			if (user.user_type == 'admin') {
				router.go('/admin/users');
			}
		}
	},

	// ------ READY ------

	ready() {
		this.isLogin();
		$('#email').focus();
	}
}
</script>


// WEBPACK FOOTER //
// Admin-login.vue?f454ce7c